import React, { useEffect, useState } from 'react';
import { useNavigate, generatePath, Link, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DataTable from 'react-data-table-component';
import { useParams } from 'react-router';
import './styles/LinemanMilkStock.css';

function LinemanMilkStock() {
  
  const apireq05042024 = process.env.REACT_APP_SERVER_API_URL+"/";
  
  const navigate = useNavigate();
  const [UserMasterDataGlobal, setUserMasterDataGlobal] = useState([]);
  const [CollectionUsers, setCollectionUsers] = useState([]);
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());

  const usernameglobal = JSON.parse(localStorage.getItem('username'));
  const localstorage_id = JSON.parse(localStorage.getItem('localstorage_id'));
  const [defaultroutename, setdefaultroutename] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apireq05042024+`UserMaster/getdatabyusername?username=${usernameglobal}&localstorage_id=${localstorage_id}`);
        if(response.data == "logout") {
          navigatetologin();
        }
        if(response.data.UserMasterDataGlobal?.[0]?.accessto == "COLLECTION" && response.data.UserMasterDataGlobal?.[0]?.CompanyId != "5") {
          navigate('/DailyDeliverySheet');
        }
        if(response.data.UserMasterDataGlobal?.[0]?.accessto == "COLLECTION" && response.data.UserMasterDataGlobal?.[0]?.CompanyId == "5") {
          navigate('/DailyDeliverySheet_jadhav');
        }
        if ((response.data.CollectionUsersData.length > 0)) {
          const collectionUsersArray = [];
          response.data.CollectionUsersData.forEach(user => {
              collectionUsersArray.push(user);
          });
          setCollectionUsers(collectionUsersArray);
          setdefaultcollectionuser(response.data.CollectionUsersData[0].userid)
        }        
        else {
          alert('Please add Lineman users to use this form');
        }
        setUserMasterDataGlobal(response.data.UserMasterDataGlobal);
        // Check and iterate through CollectionUsersData if it exists

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Initial fetch if usernameglobal is available
    if (usernameglobal) {
      fetchData();
    }

    // Set up interval to fetch data every 5 minutes
    const intervalId = setInterval(fetchData, 5 * 60 * 1000); // 5 minutes in milliseconds

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [usernameglobal]); // Dependency array includes usernameglobal

  useEffect(() => {
    if (usernameglobal === null) {
      navigate('/LoginPage');
    } else {
      // Reset last activity time whenever there's user interaction
      const handleUserActivity = () => {
        setLastActivityTime(Date.now());
      };

      window.addEventListener('mousemove', handleUserActivity);
      window.addEventListener('keydown', handleUserActivity);
      window.addEventListener('touchstart', handleUserActivity); // For touch devices

      return () => {
        window.removeEventListener('mousemove', handleUserActivity);
        window.removeEventListener('keydown', handleUserActivity);
        window.removeEventListener('touchstart', handleUserActivity);
      };
    }
  }, [usernameglobal, navigate]);

  useEffect(() => {
    const sessionTimeout = setTimeout(() => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - lastActivityTime;

      if (elapsedTime > 15 * 60 * 1000) { // Log out after 15 minutes of inactivity
        console.log('Logging out due to inactivity...');
        navigatetologin();
      } else {
        // If there's less than 15 minutes left, reset the timeout to avoid unnecessary checks
        sessionTimeout.refresh();
      }
    }, 15 * 60 * 1000); // Check for inactivity every 15 minutes (converted to milliseconds)

    return () => clearTimeout(sessionTimeout);
  }, [lastActivityTime, navigatetologin]);

  // console.log(UserMasterDataGlobal[0].usertype);
  async function navigatetologin() {
    const response = await axios.get(apireq05042024+`UserMaster/logout?username=${usernameglobal}`);
    localStorage.removeItem('username');
    localStorage.removeItem('localstorage_id');
    navigate('/loginpage');
  } 

  const MySwal = withReactContent(Swal);
  const [errors, seterrors] = useState({});
  const [CustomerMasterData, setCustomerMasterData] = useState([]);  
  const [defaultcenter, setdefaultcenter] = useState();
  const [defaultcollectionuser, setdefaultcollectionuser] = useState();
  const [CenterMasterData, setCenterMasterData] = useState([]);
  const [RouteMasterData, setRouteMasterData] = useState([]);
  const [LinemanMilkStockData, setLinemanMilkStockData] = useState([]);

  var cowratib_qty2 = 0.00;
  var buffratib_qty2 = 0.00;

  function CustomerMasterDataUpdateonCenteridchange(centerid = null, routename = null){
    var urllink=apireq05042024+'CustomerMaster/GetCustomerMasterDatabyCenteridAndRoutecode?CompanyId='+UserMasterDataGlobal?.[0]?.CompanyId+'&centerid='+centerid+'&routename='+routename;

    axios.get(urllink)
        .then((response) => {

          // Access the response data directly using response.data
          setCustomerMasterData(response.data.CustomerMasterData);
        })
        .catch((error) => console.error('Error fetching data:', error));
  }

  //2) using axios
  useEffect(() => {
  // Fetch data from the specified URL
    if (UserMasterDataGlobal.length > 0) {

      if(UserMasterDataGlobal?.[0]?.usertype  !== "ADMIN" &&  UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER"){
        var urllink=apireq05042024+'CustomerMaster?CompanyId='+UserMasterDataGlobal?.[0]?.CompanyId+'&centerid='+UserMasterDataGlobal?.[0]?.centerid;
      } else {
        var urllink=apireq05042024+'CustomerMaster?CompanyId='+UserMasterDataGlobal?.[0]?.CompanyId+'&centerid='+UserMasterDataGlobal?.[0]?.centerid;
      }

      axios.get(urllink)
        .then((response) => {
          // Access the response data directly using response.data
          if(!defaultcenter){
            setCustomerMasterData(response.data.CustomerMasterData);
          }
        })
        .catch((error) => console.error('Error fetching data:', error));
    }
  }, [UserMasterDataGlobal]);

  //2) using axios
  useEffect(() => {
  // Fetch data from the specified URL
    if (UserMasterDataGlobal.length > 0) {
      const req = apireq05042024+`CenterMaster?CompanyId=${UserMasterDataGlobal[0]?.CompanyId}`;
      axios.get(req)
      .then((response) => {
        // Access the response data directly using response.data
        
        if(!defaultcenter){
          setCenterMasterData(response.data.CenterMasterData);
          setdefaultcenter(response.data.CenterMasterData[0].centerid);
          if(UserMasterDataGlobal?.[0]?.usertype !== "ADMIN" && UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER") {
            setdefaultcenter(UserMasterDataGlobal?.[0]?.centerid);
            setFormData({
              ...formData,
              centerid: UserMasterDataGlobal?.[0]?.centerid,
            })
          }
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
    }
  }, [UserMasterDataGlobal]);

  //2) using axios
  useEffect(() => {
    if (UserMasterDataGlobal.length > 0 && defaultcenter) {
      setRouteMasterData([]);
      const axiostoapi = apireq05042024+`RouteMaster/GetRouteByCenterIdAndCompanyId/${UserMasterDataGlobal[0]?.CompanyId}/${defaultcenter}`;
      axios.get(axiostoapi)
        .then((response) => {
          setRouteMasterData(response.data.RouteMasterData);
          
          CustomerMasterDataUpdateonCenteridchange(defaultcenter, response.data.RouteMasterData[0].routename);
         
          setdefaultroutename(response.data.RouteMasterData[0].routename);
        })
        .catch((error) => console.error('Error fetching route data:', error));
    }
  //we put defaultcenter below because when its value changes everytime this routemaster useeffect code will get executed
  }, [UserMasterDataGlobal, defaultcenter]);

  const [formData, setFormData] = useState({
    // tran_date: "",
    tran_date: new Date().toISOString().split('T')[0],
    centerid: "",
    routename: "",
    lineman_user_id: "",
    cow_given_qty: "",
    cow_returned_qty: "",
    buff_given_qty: "",
    buff_returned_qty: "",
  });

  
    //2) using axios
    useEffect(() => {
      if (UserMasterDataGlobal.length > 0 && formData.tran_date != '') {
        const axiostoapi = apireq05042024+`LinemanMilkStock/getDataParticularDate/${UserMasterDataGlobal[0]?.CompanyId}/${formData.tran_date}`;
        // console.log(axiostoapi);
        axios.get(axiostoapi)
          .then((response) => {
              if(response.status === 200) {
                if (Array.isArray(response.data.result) && response.data.result.length > 0) {
                  // console.log(response.data.result);
                  setLinemanMilkStockData(response.data.result);                  
                }
                else {
                  setLinemanMilkStockData([]); 
                }
              }
          })
          .catch((error) => console.error('Error fetching route data:', error));
      }
    //we put defaultcenter below because when its value changes everytime this routemaster useeffect code will get executed
    }, [UserMasterDataGlobal, formData.tran_date]);  

  const [records, setRecords] = useState([]);
  const [search, setSearch] = useState("");

  const handleInputChange = (e) => {
    // const { id, value } = e.target;
    // setFormData((prev) => ({
    //   ...prev,
    //   [id]: value,
    // }));

    const { name, value } = e.target;
    
    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    if(name == "centerid"){
      setdefaultcenter(value);
    }
    
    if(name == "routename"){
      setdefaultroutename(value);
    }

    if(name == "linemanname") {
      setdefaultcollectionuser(value);
    }

    setFormData(updatedFormData);

  };

  const handleSave = () => {
    // setRecords((prev) => [...prev, formData]);
    // setFormData({
    //   tran_date: "",
    //   centerName: "Center A",
    //   lineNo: "",
    //   lineName: "Line 1",
    //   linemanNo: "",
    //   linemanName: "Lineman A",
    //   given_qty: "",
    //   returned_qty: "",
    // });
  };

  // const handleDelete = (index) => {
  //   setRecords((prev) => prev.filter((_, i) => i !== index));
  // };

  // const filteredRecords = records.filter((record) =>
  //   Object.values(record).some((value) =>
  //     value.toString().toLowerCase().includes(search.toLowerCase())
  //   )
  // );

  const getCenterNameById = (centerid) => {
    const center = CenterMasterData.find(center => center.centerid === centerid);
    return center ? center.centername : '';
  };

  const getUserNameById = (userid) => {
    const user = CollectionUsers.find(user => user.userid === userid);
    return user ? user.username : '';
  };

  const [isEditing, setIsEditing] = useState(false); // Tracks whether editing or adding
  const [currentRecord, setCurrentRecord] = useState(null); // Current record being edited
  
  // Function to handle edit button click
  const getdatabyrecordarray = (record) => {
    setIsEditing(true);
    setCurrentRecord(record);
    setdefaultcenter(record.centerid);
    setdefaultroutename(record.routename);
    setFormData({
      tran_date: record.tran_date,
      centerid: record.centerid,
      routename: record.routename,
      cow_given_qty: record.cow_given_qty,
      cow_returned_qty: record.cow_returned_qty,
      buff_given_qty: record.buff_given_qty,
      buff_returned_qty: record.buff_returned_qty,
      lineman_user_id: record.lineman_user_id,
    });
  };
  
  // Updated handleSubmit function
  const handleSubmit = async (event) => {
    event.preventDefault();
  
    const formData = new FormData(event.target);
  
    let validationerrors = {};
  
    if (formData.get("tran_date").trim() === "") {
      validationerrors.tran_date = "Please enter a valid date.";
    }
    if (formData.get("cow_given_qty").trim() === "" && formData.get("buff_given_qty").trim() === "") {
      MySwal.fire({
        html: <b>Either Cow or Buff Qty is required</b>,
        icon: "warning",
      });
    }
  
    // setErrors(validationerrors);
  
    if (Object.keys(validationerrors).length === 0) {
      const data = {
        CompanyId: UserMasterDataGlobal?.[0]?.CompanyId,
        userid: UserMasterDataGlobal?.[0]?.userid,
        tran_date: formData.get("tran_date"),
        centerid: formData.get("centerid"),
        routename: formData.get("routename"),
        cow_given_qty: formData.get("cow_given_qty"),
        cow_returned_qty: formData.get("cow_returned_qty"),
        buff_given_qty: formData.get("buff_given_qty"),
        buff_returned_qty: formData.get("buff_returned_qty"),
        lineman_user_id: formData.get("lineman_user_id"),
      };
      
      if (isEditing) {
        // Update record
        const response = await axios.put(apireq05042024 + `LinemanMilkStock/update/${currentRecord.id}`, data);
        if (response.status === 200) {
          if(formData)
          setLinemanMilkStockData((prevData) =>
            prevData.map((item) =>
              item.id === currentRecord.id ? { ...item, ...data } : item
            )
          );
          setIsEditing(false);
          setCurrentRecord(null);
          MySwal.fire({
            html: <b>Record updated successfully!</b>,
            icon: "success",
          });
        }
      } else {
        // Add new record
        const response = await axios.post(apireq05042024 + "LinemanMilkStock/insert", data);
        if (response.status === 200) {
          if(response.data.message == "A record for this user already exists on the same date. If you want to make changes, please edit the existing record.") {
            MySwal.fire({
              html: <b>A record for this user already exists on the same date. If you want to make changes, please edit the existing record.</b>,
              icon: "warning",
            });
            return;
          }
          setLinemanMilkStockData((prevData) => [
            { ...data, id: response.data.id },
            ...prevData,
          ]);
          MySwal.fire({
            html: <b>Record added successfully!</b>,
            icon: "success",
          });
        }
      }
  
      setFormData({
        tran_date: data.tran_date,
        centerid: "",
        routename: "",
        cow_given_qty: "",
        cow_returned_qty: "",
        buff_given_qty: "",
        buff_returned_qty: "",
        lineman_user_id: "",
      });
    }
  };
  
  // Function to cancel editing
  const cancelEdit = () => {
    setIsEditing(false);
    setCurrentRecord(null);
    setFormData({
      tran_date: "",
      centerid: "",
      routename: "",
      cow_given_qty: "",
      cow_returned_qty: "",
      buff_given_qty: "",
      buff_returned_qty: "",
      lineman_user_id: "",
    });
  };

  function confirmDelete(event, id) {
      event.preventDefault();

      MySwal.fire({
          title: 'Are you sure you want to delete the record?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
          if (result.isConfirmed) {
              if (result.value) {
              // window.location.href = $(this).attr('href');
              deleteData(id);
              }
          }
      })
  }

  async function deleteData(id) {

    const response = await axios.delete(apireq05042024+`LinemanMilkStock/delete/${id}/${UserMasterDataGlobal?.[0]?.CompanyId}`);
    
    if (response.status === 200) {
      // The record was deleted successfully.
      // console.log('Record deleted successfully!');
        if(response.data.message==="Record deleted Successfully") {
            MySwal.fire({
              //   title: <strong>Record Saved Sucessfully!</strong>,
              html: <b>Record deleted Sucessfully!</b>,
              icon: 'success'
            })
            setLinemanMilkStockData((prevData) => prevData.filter((record) => record.id !== id));
               
        } 
    } else {
        MySwal.fire({
        //   title: <strong>Record Saved Sucessfully!</strong>,
            html: <b>Record not deleted! Please try once again or call the developer</b>,
            icon: 'error'
        })
    }
  }
  
  return (
    <div className="lineman-stock-page">
      <h1 style={{ color: 'white', backgroundColor: '#4229cb', padding: '9px', cursor: 'default', fontSize: 20 }} className="text-center"> Lineman Stock Master</h1>
        <nav style={{ marginTop: -8, marginBottom: 18 }} className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid" style={{color: 'black', color: 'rgb(230 238 247)', backgroundColor: 'rgb(0, 152, 121)', marginTop:'-8px', borderBottom: 'none', position: 'absolute'}}>

            <a className="navbar-brand" style={{color: 'rgb(230 238 247)'}} href="/" >Home</a>
            <ul className="navbar-nav">
                <li className="nav-item">
                    <span className="nav-link" style={{cursor: 'default'}}>{`Welcome ${UserMasterDataGlobal?.[0]?.username}`}</span>
                </li>
            </ul>
            <a className="navbar-brand" onClick={navigatetologin} style={{ cursor: 'pointer', color: 'rgb(230 238 247)' }}>Log out</a>
            </div>
        </nav>


        <div className="container">
          <h1>Lineman Stock Form</h1>
          {/* <form id="crud-form" onSubmit={(e) => e.preventDefault()}> */}
          <form onSubmit={handleSubmit} method="POST" id="form1">
            <div className="form-group">
              <label>Date:</label>
              <input
                type="date"
                id="date"
                name="tran_date"
                value={formData.tran_date}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="id-centerName" className="form-label">Select Center Name</label>

                <select
                  className="form-select"
                  id="id-centerid"
                  name="centerid" // <-- should match `formData.uom1` property
                  value={formData.centerid}
                  onChange={handleInputChange}
                  // disabled={
                  //   UserMasterDataGlobal?.[0]?.usertype !== "ADMIN" &&
                  //   UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER"
                  // }
                >
                {defaultcenter && (
                  <option key={defaultcenter} value={defaultcenter}>
                    {getCenterNameById(defaultcenter)}
                  </option>
                )}

                {/* dynamically fetched options */}
                {CenterMasterData.map((cp) => (
                  defaultcenter !== cp.centerid ?
                    <option key={cp.centerid} value={cp.centerid} >
                      {cp.centername}
                    </option>
                  : null
                ))}
                </select>

            </div>

            <div className="form-group">
                <label htmlFor="id-routename" className="form-label">Line No</label>
                <select
                  className="form-select"
                  id="id-routename" 
                  name="routename"
                  value={formData.routename}
                  onChange={handleInputChange}
                >

                {defaultroutename && (
                  <option value={defaultroutename}>
                    {defaultroutename}
                  </option>
                )}

                {RouteMasterData.map((r) => (
                    defaultroutename !== r.routename ?
                    <option key={r.routecode} value={r.routename}>
                      {r.routename}
                    </option>
                    : null
                ))}
                </select>
            </div>

            <div className="form-group">
              <label htmlFor="id-linemanname" className="form-label">Select Lineman Name</label>

              <select
                className="form-select"
                name="lineman_user_id" // <-- should match `formData.uom1` property
                value={formData.lineman_user_id}
                onChange={handleInputChange}
                // disabled={
                //   UserMasterDataGlobal?.[0]?.usertype !== "ADMIN" &&
                //   UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER"
                // }
              >
              {defaultcollectionuser && (
                <option key={defaultcollectionuser} value={defaultcollectionuser}>
                  {getUserNameById(defaultcollectionuser)}
                </option>
              )}

              {/* dynamically fetched options */}
              {CollectionUsers.map((cp) => (
                defaultcollectionuser !== cp.userid ?
                  <option key={cp.userid} value={cp.userid} >
                    {cp.username}
                  </option>
                : null
              ))}
              </select>
            </div>

            <div className="form-group">
              <label>Cow Given Qty:</label>
              <input
                type="number"
                id="cow_given_qty"
                name="cow_given_qty"
                value={formData.cow_given_qty}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Cow Returned Qty:</label>
              <input
                type="number"
                id="cow_returned_qty"
                name="cow_returned_qty"
                value={formData.cow_returned_qty}
                onChange={handleInputChange}
                
              />
            </div>

            <div className="form-group">
              <label>Buff Given Qty:</label>
              <input
                type="number"
                id="buff_given_qty"
                name="buff_given_qty"
                value={formData.buff_given_qty}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Buff Returned Qty:</label>
              <input
                type="number"
                id="buff_returned_qty"
                name="buff_returned_qty"
                value={formData.buff_returned_qty}
                onChange={handleInputChange}
                
              />
            </div>
            
            <div className="form-group">
            <button type="submit">{isEditing ? "Update" : "Save"}</button>
            {isEditing && <button type="button" onClick={cancelEdit}>Cancel</button>}
            </div>
            
          </form>

          <h2>Saved Records</h2>
          <input
            type="text"
            id="search"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className="col-md-12 table-responsive-xl">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Center Name</th>
                  <th>Line Name</th>
                  <th>Lineman Name</th>
                  <th>Cow Given Qty</th>
                  <th>Cow Returned Qty</th>
                  <th>Buff Given Qty</th>
                  <th>Buff Returned Qty</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {LinemanMilkStockData.map((record, index) => (
                  <tr key={index}>
                    <td>{record.tran_date}</td>
                    <td>{getCenterNameById(record.centerid)}</td>
                    <td>{record.routename}</td>
                    <td>{getUserNameById(record.lineman_user_id)}</td>
                    <td>{record.cow_given_qty}</td>
                    <td>{record.cow_returned_qty}</td>
                    <td>{record.buff_given_qty}</td>
                    <td>{record.buff_returned_qty}</td>
                    <td>
                      <button onClick={() => getdatabyrecordarray(record)} className="btn btn-info btn-sm">Edit</button>
                      <button onClick={(event) => confirmDelete(event, record.id)} className="btn btn-info btn-sm">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      {/* </form> */}
    </div>
  );
};

export default LinemanMilkStock;
